module.exports = __webpack_public_path__ + "img/pre-sale.4e86c143.svg";